/// <amd-module name="TFS/Admin/Groups/Common/Redux/DataSource/MemberValidationDataSource" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

const AdminTeamsDataProvider = "ms.vss-admin-web.org-admin-member-validation-data-provider";

export function validateMember(pageContext: IVssPageContext, requestParameters?: { [key: string]: any }): Promise<any> {
    const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");

    return contributionService.getDataAsync<any>(AdminTeamsDataProvider, requestParameters, true).then(result => {
        return result;
    });
}